import { render, staticRenderFns } from "./SuggestionKeywordsBlacklist.vue?vue&type=template&id=097b2b67&scoped=true"
import script from "./SuggestionKeywordsBlacklist.vue?vue&type=script&lang=js"
export * from "./SuggestionKeywordsBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b2b67",
  null
  
)

export default component.exports